<template>
	<path d="M3 6L8 11L13 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</template>
